export const PRE_SALE_INFO_PDF = `/forkopinformation`;
export const POLICY_AGREEMENT_PDF = `/villkor`;
export const PRODUCT_FACT_PDF = `/produktfaktablad`;
